import { CitationType, NamespaceType } from '../citations/citations';

const GlobalNamespaceID = '<GLOBAL>';

export interface FunctionStart {
  function_name: string;
  function_description: string;
  function_call_id: string;
  session_event_id?: string;
  namespace_type?: string;
  namespace_id?: string;
}

export interface FunctionComplete {
  function_name: string;
  function_call_id: string;
  session_event_id?: string;
  namespace_type?: string;
  namespace_id?: string;
}

export interface CitationAdapter {
  type(): CitationType;
  title(): string;
  description(): string;
  link(): string;
  sessionEventId(): string;
  namespaceType(): string;
  namespaceID(): string;
  fileUrl(): string;
}

export abstract class CitationCommon implements CitationAdapter {
  namespaceType(): string {
    return NamespaceType.GLOBAL;
  }
  namespaceID(): string {
    return '<GLOBAL>';
  }
  abstract type(): CitationType;
  abstract title(): string;
  abstract description(): string;
  abstract link(): string;
  abstract sessionEventId(): string;
  abstract fileUrl(): string;
}

export class FunctionStartCitation extends CitationCommon {
  constructor(private readonly functionStart: FunctionStart) {
    super();
  }

  type(): CitationType {
    return CitationType.TYPE_FUNCTION_CALL;
  }
  title(): string {
    return this.functionStart.function_name;
  }
  description(): string {
    return this.functionStart.function_description;
  }
  link(): string {
    return '';
  }
  sessionEventId(): string {
    return this.functionStart.session_event_id || '';
  }
  namespaceType(): string {
    return this.functionStart.namespace_type || NamespaceType.GLOBAL;
  }
  namespaceID(): string {
    return this.functionStart.namespace_id || GlobalNamespaceID;
  }
  fileUrl(): string {
    return '';
  }
}

export class FunctionCompleteCitation extends CitationCommon {
  constructor(private readonly functionComplete: FunctionComplete) {
    super();
  }

  type(): CitationType {
    return CitationType.TYPE_FUNCTION_CALL;
  }
  title(): string {
    return this.functionComplete.function_name;
  }
  description(): string {
    return '';
  }
  link(): string {
    return '';
  }
  sessionEventId(): string {
    return this.functionComplete.session_event_id || '';
  }
  namespaceType(): string {
    return this.functionComplete.namespace_type || NamespaceType.GLOBAL;
  }
  namespaceID(): string {
    return this.functionComplete.namespace_id || GlobalNamespaceID;
  }
  fileUrl(): string {
    return '';
  }
}
